import { Column } from "@/components/Column";
import { DashboardTable } from "@/components/dashboard/DashboardTable";
import { DashboardTableMinimized } from "@/components/dashboard/DashboardTableMinimized";

import {
  DashboardJob,
  DashboardSelectedUser,
  DashboardSortState,
} from "@/types";

export const DashboardTableContainer = ({
  calendarExpanded,
  isGroupedByStaffer,
  onGroupedByStafferChange,
  sort,
  sortedJobs,
  onSortChange,
  onReviewJob,
  onReviewSearchJob,
  isLoading,
  selectedUserId,
}: {
  calendarExpanded: boolean;
  isGroupedByStaffer: boolean;
  onGroupedByStafferChange: (next: boolean) => void;
  sort: DashboardSortState | null;
  sortedJobs: DashboardJob[];
  onSortChange: (next: DashboardSortState | null) => void;
  onReviewJob: (job: DashboardJob, groupStafferId?: number) => void;
  onReviewSearchJob: (job: DashboardJob) => void;
  isLoading: boolean;
  selectedUserId: DashboardSelectedUser;
}) => {
  const render = () => {
    if (calendarExpanded) {
      return (
        <DashboardTableMinimized
          sort={sort}
          sortedJobs={sortedJobs}
          onSortChange={onSortChange}
          isLoading={isLoading}
        />
      );
    }
    return (
      <Column className="min-h-0 min-w-0 flex-1">
        <DashboardTable
          isGroupedByStaffer={isGroupedByStaffer}
          onGroupedByStafferChange={onGroupedByStafferChange}
          sort={sort}
          sortedJobs={sortedJobs}
          onSortChange={onSortChange}
          onReviewJob={onReviewJob}
          onReviewSearchJob={onReviewSearchJob}
          isLoading={isLoading}
          selectedUserId={selectedUserId}
        />
      </Column>
    );
  };

  return render();
};
